<template>
  <a-modal
    :visible="visible"
    @cancel="handleCancel"
    :maskClosable="false"
    :title="$t('device_form_param1_ftp')"
    @ok="handleOk"
    width="80%"
    destroyOnClose
    :confirmLoading="confirmLoading"
  >
    <!-- 搜索条件  -->
    <div class="attachment-search">
      <a-form :form="form" layout="horizontal" class="attachment-search-form">
        <a-form-item :label="null" prop="name" style="flex:1">
          <a-input
            :placeholder="$t('attachment.search.name.placeholder')"
            v-model="params.name"
            allowClear
            @pressEnter="getDataList"
            @change="
              () => {
                if (!params.name) {
                  this.getDataList();
                }
              }
            "
          />
        </a-form-item>

        <a-form-model-item :label="null" prop="createBy" v-if="userList && userList.length">
          <a-select
            v-model="params.createBy"
            :placeholder="$t('attachment.search.createby.placeholder')"
            allowClear
            @change="createByChange"
            style="width:150px"
            :filter-option="filterOption"
            show-search
          >
            <a-select-option :value="user.userId" v-for="user in userList" :key="user.userId">
              {{ user.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form>
      <div class="attachment-search-btn">
        <a-button type="primary" @click="getDataList">
          {{ $t('com_btn_lookfor') }}
        </a-button>

        <a-button
          type="default"
          @click="
            () => {
              this.params = {
                createBy: undefined,
                name: '',
              };
              this.form.resetFields();
              this.getDataList();
            }
          "
        >
          {{ $t('com_btn_reset') }}
        </a-button>
      </div>
    </div>
    <div class="attachment-table g-table">
      <a-radio-group v-model="selectValue" @change="onSelect" style="width: 100%;" size="large">
        <!-- 列表 -->
        <a-table
          :columns="columns"
          :data-source="currentDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleParamTable"
          :loading="loading"
          size="small"
        >
          <template slot="attachName" slot-scope="name, record">
            <!-- 鼠标移到名称上超过2秒显示简要介绍 -->
            <a-popover placement="top" title="" trigger="hover">
              <template slot="content">
                <div class="tree-intro">
                  <h5 :class="{ 'tree-intro-title': record.intro }">{{ name }}</h5>
                  <div class="tree-intro-content" v-if="record.intro">
                    {{ record.intro }}
                  </div>
                </div>
              </template>

              <div class="attach-name">
                <Icon :type="fileIcons(name)" />
                <p>
                  <span
                    v-for="(part, index) in highlightKeyword(name, finallyKeyword)"
                    :key="index"
                    :class="part.isKeyword ? 'highlight' : ''"
                    >{{ part.text }}</span
                  >
                </p>
              </div>
            </a-popover>
          </template>

          <!-- 类型 -->
          <template slot="Select" slot-scope="text">
            <a-radio :value="text" />
          </template>

          <!-- 创建时间 -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>
        </a-table>
      </a-radio-group>

      <div class="pagination">
        <Pagination
          :current.sync="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="pageChange"
          @change="pageChange"
          :showSizeChanger="false"
          style="padding-bottom: 0;"
        />
      </div>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/attach';
import { generateSignedUrl } from '@/config/oss';
import { UserList } from '@/api/system/user';
import fileIcons from '@/config/fileIcons';

export default {
  props: {
    visible: {
      type: Boolean,
      default: null,
    },

    // 是否使用短url
    shortUrl: {
      type: Boolean,
      default: false,
    },

    // 上传bucket
    uploadBucket: {
      type: String,
      default: '',
    },

    // 附件类型
    attachType: {
      type: [Number, undefined],
      default: undefined,
    },
  },
  data() {
    return {
      fileIcons,
      form: this.$form.createForm(this, { name: 'attachmentSearch' }),
      selected: '',
      params: {
        createBy: undefined,
        name: null,
      },
      finallyKeyword: '',

      createByList: [],

      currentDataList: [],

      columns: [
        {
          title: this.$t('attachment.table.select'),
          dataIndex: 'id',
          scopedSlots: { customRender: 'Select' },
          width: 80,
          align: 'center',
        },
        {
          title: this.$t('attachment.table.dir'),
          dataIndex: 'parentName',
        },

        {
          title: this.$t('attach_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'attachName' },
        },
        {
          title: this.$t('attachment.table.createby'),
          dataIndex: 'createUserName',
        },

        {
          title: this.$t('attachment.table.createTime'),
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
          sorter: true,
        },
      ],

      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序
        orderType: 1,
        orderField: 2,
      },

      // 选择的attachment url
      selectValue: '',
      selectData: null,

      confirmLoading: false,

      loading: false,

      userListAll: [],
      userList: [],
    };
  },

  created() {
    this.getUserList();
    this.getDataList();
  },

  methods: {
    // 选择创建人
    createByChange(value) {
      this.params.createBy = value;
      this.getDataList();
    },

    // 获取用户列表
    getUserList() {
      const params = {
        pageNo: 1,
        pageSize: 10000,
      };
      return UserList(params).then(res => {
        if (res.code === 0) {
          this.userListAll = res.data || [];
          this.userList = res.data || [];
        }
      });
    },

    // 搜索用户(前端匹配)
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    handleCancel() {
      this.$emit('cancel');
    },

    async handleOk() {
      this.confirmLoading = true;
      if (!this.selectData) {
        this.$emit('cancel');
        return;
      }
      // 生成签名url: 文件名，过期时间，是否登录，bucket
      const _url = await generateSignedUrl({
        objectKey: this.selectData.url,
        uploadBucket: this.uploadBucket,
        shortUrl: this.shortUrl ? true : false,
      });

      this.confirmLoading = false;
      this.$emit('ok', _url);
    },

    pageChange(page) {
      this.pagination.current = page;
      this.getDataList();
    },

    // 获取数据
    getDataList(_params = {}) {
      const params = {
        dirId: 0,
        keyword: this.params.name,
        createBy: this.params.createBy,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        orderType: this.pagination.orderType,
        orderField: this.pagination.orderField,
        ...(_params || {}),
      };

      // 类型
      if (typeof this.attachType !== 'undefined') {
        params.type = this.attachType;
      }

      this.finallyKeyword = params.keyword;

      this.loading = true;
      return API.searchFilesAndFolders(params)
        .then(res => {
          this.currentDataList = res.data;
          this.pagination.total = res.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择
    onSelect(event) {
      const _id = event.target.value;
      // 找到对应的数据
      const _data = this.currentDataList.find(item => item.id === _id);
      this.selectValue = event.target.value;
      this.selectData = _data;
    },

    // 高亮搜索关键字
    highlightKeyword(text, keyword) {
      if (!keyword) {
        return [
          {
            text: text,
            isKeyword: false,
          },
        ];
      }
      const regex = new RegExp(`(${keyword})`, 'gi'); // 匹配关键字，忽略大小写
      const parts = text.split(regex); // 分割文本
      const newParts = [];
      parts.forEach(part => {
        const _part = {
          text: part,
          isKeyword: regex.test(part),
        };
        newParts.push(_part);
      });
      return newParts;
    },

    handleParamTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'createTime') {
        orderField = 2;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.pagination.orderType = orderType;
      this.pagination.orderField = orderField;

      this.getDataList({
        orderField,
        orderType,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tree-intro {
  max-width: 360px;
  word-wrap: break-word;
  word-break: break-all;

  .tree-intro-content {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }

  h5 {
    padding: 0;
    font-weight: bold;
    font-size: 16px;
    padding-top: 10px;

    &.tree-intro-title {
      border-bottom: #e8e8e8 solid 1px;
      padding-bottom: 5px;
      margin-bottom: 10px;
    }
  }
}

.highlight {
  color: #1838d9 !important;
  font-weight: bold !important;
}

.attachment-search {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  .attachment-search-form {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0;
    padding: 0;
    gap: 12px;
    width: 100%;
  }
  .attachment-search-btn {
    margin-top: 5px;
    display: flex;
    gap: 12px;
  }
}

.attachment-table {
  width: 100%;
}

.attach-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;

  svg {
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
  }
}
</style>
